module.exports = __webpack_public_path__ + "static/media/Cabaret Singer.3efaf14b.jpg";